import { render } from "./CertView.vue?vue&type=template&id=4710d0d0&scoped=true"
import script from "./CertView.vue?vue&type=script&lang=js"
export * from "./CertView.vue?vue&type=script&lang=js"

import "./CertView.vue?vue&type=style&index=0&id=4710d0d0&scoped=true&lang=css"
import "./CertView.vue?vue&type=style&index=1&id=4710d0d0&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4710d0d0"]])

export default __exports__